import React from "react";
import "./App.css";
import "./lib/firebase"; // init Firebase Analytics (no-op if env not set)
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import NetworkStatus from "./components/NetworkStatus";
import LightboxProvider from "./components/Lightbox";
import Login from "./pages/Login";
import HomeDashboard from "./pages/HomeDashboard";
import ExpiringList from "./pages/ExpiringList";
import CategoryListPage from "./pages/CategoryListPage";
import DeviceDetail from "./pages/DeviceDetail";
import Clients from "./pages/Clients";
import ScaffoldDetail from "./pages/ScaffoldDetail";
import Gallery from "./pages/Gallery";
import PublicCheck from "./pages/PublicCheck";
import PhotoView from "./pages/PhotoView";
import Manuals from "./pages/Manuals";

function ProtectedLayout({ children }) {
  return (
    <ProtectedRoute>
      <div className="App">
        <Navbar />
        <NetworkStatus />
        {children}
      </div>
    </ProtectedRoute>
  );
}

function AdminOnly({ children }) {
  const { isAdmin, user } = useAuth();
  if (user === null) return null;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}

function LegacyAnticadutaRedirect() {
  const { pathname, search } = useLocation();
  return <Navigate to={pathname.replace(/^\/lineevita/, "/anticaduta") + search} replace />;
}


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/check/:kind/:id" element={<PublicCheck />} />
          <Route path="/" element={<ProtectedLayout><HomeDashboard /></ProtectedLayout>} />
          <Route path="/scadenze" element={<ProtectedLayout><ExpiringList /></ProtectedLayout>} />

          {/* DPI */}
          <Route path="/dpi" element={<ProtectedLayout><CategoryListPage categoryKey="dpi" /></ProtectedLayout>} />
          <Route path="/dpi/clienti/:clientId" element={<ProtectedLayout><CategoryListPage categoryKey="dpi" /></ProtectedLayout>} />

          {/* Strumenti */}
          <Route path="/strumenti" element={<ProtectedLayout><CategoryListPage categoryKey="strumento" /></ProtectedLayout>} />
          <Route path="/strumenti/clienti/:clientId" element={<ProtectedLayout><CategoryListPage categoryKey="strumento" /></ProtectedLayout>} />
          <Route path="/strumenti/:id" element={<ProtectedLayout><DeviceDetail /></ProtectedLayout>} />

          {/* Scaffalature */}
          <Route path="/scaffolds" element={<ProtectedLayout><CategoryListPage categoryKey="scaffalatura" /></ProtectedLayout>} />
          <Route path="/scaffolds/clienti/:clientId" element={<ProtectedLayout><CategoryListPage categoryKey="scaffalatura" /></ProtectedLayout>} />
          <Route path="/scaffolds/:id" element={<ProtectedLayout><ScaffoldDetail /></ProtectedLayout>} />

          {/* Anticaduta */}
          <Route path="/anticaduta" element={<ProtectedLayout><CategoryListPage categoryKey="lineavita" /></ProtectedLayout>} />
          <Route path="/anticaduta/clienti/:clientId" element={<ProtectedLayout><CategoryListPage categoryKey="lineavita" /></ProtectedLayout>} />
          <Route path="/anticaduta/:id" element={<ProtectedLayout><ScaffoldDetail /></ProtectedLayout>} />
          <Route path="/lineevita/*" element={<LegacyAnticadutaRedirect />} />

          <Route path="/devices/:id" element={<ProtectedLayout><DeviceDetail /></ProtectedLayout>} />
          <Route path="/gallery" element={<ProtectedLayout><Gallery /></ProtectedLayout>} />
          <Route
            path="/view/photo/*"
            element={
              <ProtectedRoute>
                <PhotoView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedLayout>
                <AdminOnly>
                  <Clients />
                </AdminOnly>
              </ProtectedLayout>
            }
          />
          <Route
            path="/manuals"
            element={
              <ProtectedLayout>
                <AdminOnly>
                  <Manuals />
                </AdminOnly>
              </ProtectedLayout>
            }
          />
          <Route
            path="*"
            element={
              <div className="min-h-screen flex items-center justify-center">
                <div className="bru-card p-8 text-center">
                  <div className="tag-label mb-2">404</div>
                  <h1 className="text-3xl font-bold" >Pagina non trovata</h1>
                  <a href="/" className="bru-link mt-4 inline-block">Torna alla Dashboard</a>
                </div>
              </div>
            }
          />
        </Routes>
        <LightboxProvider />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
